import { zSchema } from "@zeal/common";

/** Dashboard request body; company scope comes from the authenticated session. */
export const postPreviewContractorPaymentDataBodySchema = zSchema.object({
  contractorPaymentIDs: zSchema.array(zSchema.string()).min(1),
});

export type TPostPreviewContractorPaymentDataBody = zSchema.infer<
  typeof postPreviewContractorPaymentDataBodySchema
>;

export interface IPreviewContractorPaymentDataTotals {
  readonly company_cash_requirement: number;
  readonly company_debit: number;
  readonly bill_amount: number;
  readonly gross_amount: number;
  readonly net_amount: number;
  readonly deductions: number;
}

export interface IPreviewContractorPaymentItemWorkInfo {
  readonly departmentID?: string;
  readonly work_description?: string;
  readonly service_date?: string;
}

export interface IPreviewContractorPaymentItem {
  readonly paymentItemID?: string;
  readonly createdAt?: string;
  readonly earning_type?: string;
  readonly category?: string;
  readonly quantity?: number;
  readonly rate?: number;
  readonly rate_unit?: string;
  readonly gross_amount?: number;
  readonly bill_rate?: number;
  readonly bill_amount?: number;
  readonly work_info?: IPreviewContractorPaymentItemWorkInfo;
  readonly department_name: string | null;
  readonly work_location_name: string | null;
  readonly work_location_address: string | null;
  readonly metadata?: Record<string, unknown>;
}

export interface IPreviewContractorPaymentDeductionItem {
  readonly deductionID: string;
  readonly deduction_type: string;
  readonly deduction_credit: boolean;
  readonly deduction_template_name?: string;
  readonly employee_calculated_contribution: number;
  readonly employer_calculated_contribution: number;
  readonly employee_contribution_type?: string;
  readonly employee_contribution_value?: number;
  readonly effective_start_date?: string;
  readonly effective_end_date?: string;
  readonly garnishment_case_id?: string;
  readonly garnishment_order_number?: string;
  readonly garnishment_agency_name?: string;
  readonly garnishment_agency_address?: string;
}

export interface IPreviewContractorPaymentDataItem {
  readonly contractorPaymentID: string;
  readonly contractorID: string;
  readonly companyID: string;
  readonly pay_date: string;
  readonly totals: IPreviewContractorPaymentDataTotals;
  readonly disbursement: {
    readonly method: string;
    readonly status: string;
  };
  readonly metadata: Record<string, unknown>;
  readonly deductions?: readonly IPreviewContractorPaymentDeductionItem[];
  readonly payment_items?: readonly IPreviewContractorPaymentItem[];
}
